<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查时间管理
      </div>
      <ul class="tab-wrap" style="border:none">
        <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index, tab)" v-for="(tab, index) in tabList">
          {{ tab }}
        </li>
      </ul>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>

    <div class="common-page common-body">
      <div class="flex" style="justify-content:flex-end">
        <div class="btn ml10" @click="addList()"><i class="icon-tr-newly-added"></i>新增</div>
      </div>
      <div v-if="nowIndex == 0" class="common-page common-list">
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>
                巡查时间
              </th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list1" :key="index">
              <td class="common-add">
                <el-time-picker class="flex1" type="time" value-format="HH:mm:ss" placeholder="选择时间" v-model="item.start_time"></el-time-picker>
              </td>
              <td class="common-add">
                <el-select v-model="item.z_status">
                  <el-option :value="1" label="启用"></el-option>
                  <el-option :value="0" label="停用"></el-option>
                </el-select>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="btn-box">
          <div class="l-btn" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="$router.back()">返回</div>
        </div>
      </div>

      <div v-else class="common-page common-list">
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>
                巡查时间
              </th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list1" :key="index">
              <td class="common-add">
                <el-time-picker class="flex1" type="time" value-format="HH:mm:ss" placeholder="选择时间" v-model="item.start_time"></el-time-picker>
              </td>
              <td class="common-add">
                <el-select v-model="item.z_status">
                  <el-option :value="1" label="启用"></el-option>
                  <el-option :value="0" label="停用"></el-option>
                </el-select>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="btn-box">
          <div class="l-btn" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="$router.back()">返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [{ start_time: "", z_status: 1 }],
      list1: [],
      nowIndex: 0,
      tabList: ["消防巡查", "文物巡查"],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    onSubmit() {
      //    return
      this.$post("/xuncha/xctimeadd", { get_time: this.list }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
      });
    },
    changeTab(index, it) {
      this.nowIndex = index;
    },

    getDatas() {
      if (nowIndex == 0) {
        this.getList();
      } else {
        this.getWWlist;
      }
    },
    getWWlist() {
      this.$post("/xuncha/xunchaareadetailWenWu").then((res) => {
        // return
        this.list1 = res.data || [];
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post("/xuncha/xunchatimedetail").then((res) => {
        // return
        this.list = res.data || [];
      });
    },
    del(index) {
      this.list.splice(index, 1);
    },
    addList() {
      this.list.push({ start_time: "", z_status: 1 });
    },
  },
};
</script>

<style scoped></style>
